import { createServerFn } from "@tanstack/react-start";

import {
	BOARDS_KEY_MAPPER_ENUM,
	TASKS_COLUMNS,
	USER_ROLES,
} from "@onesolution/constants";
import { authMiddleware, mondayBoards } from "@onesolution/middlewares";
import { rolesCheck } from "@onesolution/middlewares/rolesCheck";
import { mondayClient } from "@onesolution/monday/monday";
import { statusColorsToValues } from "@onesolution/utils/status";
import z from "zod";
import { wrapWithUseMutation } from "..";

const handler = createServerFn({ method: "POST" })
	.middleware([
		authMiddleware,
		mondayBoards,
		rolesCheck([USER_ROLES.Admin, USER_ROLES.Member]),
	])
	.validator(
		z.object({
			id: z.string(),
			status: z.string(),
		}),
	)
	.handler(async ({ context, data }) => {
		if (!data.id) throw new Error("id must be set to perform an update");

		const updatedOperation = await mondayClient.mutation.updateItem(
			{
				itemId: data.id,
				boardId: context.boards.tasks,
				columnValues: {
					[TASKS_COLUMNS.status]: (
						await statusColorsToValues(
							BOARDS_KEY_MAPPER_ENUM.tasks,
							TASKS_COLUMNS.status,
							[data.status!],
						)
					)?.[0],
				},
			},
			context,
		);

		if (!updatedOperation) {
			throw { error: "Error while updating operation." };
		}

		return updatedOperation;
	});

export const updateTaskStatusOnServer = wrapWithUseMutation<
	typeof handler,
	{ id: string; status: string }
>(handler);
